module.exports = __webpack_public_path__ + "img/person-checkmark.8795e415.svg";